"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.officeLoginConfigDefaultValue = exports.officeLoginConfigSchema = exports.AllLoginOptionsTypes = exports.AllLoginOptions = exports.LoginOptionsTypes = exports.LoginOptions = exports.OIDC_PROVIDER_PREFIX = void 0;
const zod_1 = require("zod");
exports.OIDC_PROVIDER_PREFIX = 'oidc:';
exports.LoginOptions = {
    USER_PASSWORD: 'usuario-e-senha',
    MAGIC_LINK: 'link-no-email',
    GOOGLE_SOCIAL: 'google',
    MICROSOFT_SOCIAL: 'microsoft',
};
exports.LoginOptionsTypes = {
    USER_PASSWORD: 'usuario-e-senha',
    MAGIC_LINK: 'link-no-email',
    GOOGLE_SOCIAL: 'google',
    MICROSOFT_SOCIAL: 'microsoft',
};
exports.AllLoginOptions = Object.values(exports.LoginOptions);
exports.AllLoginOptionsTypes = Object.values(exports.LoginOptionsTypes);
exports.officeLoginConfigSchema = zod_1.z.object({
    allowed_methods: zod_1.z.array(zod_1.z.string()),
    isMagicLink: zod_1.z.boolean().optional(),
    password_expiration_days: zod_1.z.number().int().min(20).optional(),
    max_wrong_login_attempts: zod_1.z.number().int().min(1).optional(),
});
const defaultValue = {
    allowed_methods: exports.AllLoginOptions,
    max_wrong_login_attempts: 10,
    password_expiration_days: 10,
};
exports.officeLoginConfigDefaultValue = JSON.stringify(defaultValue, null, '\t');
